import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import StyledFooterWrapper from '../../styles/StyledFooterWrapper';


const Footer = () => (
    <StyledFooterWrapper>
        <div className="hc-footer top-shadow">
            <Container>
                <footer className='footer footer-div'>
                    <div className="navigation-footer-branding">
                        <Link to='/'><img className="footer-logo" src='/images/HallmarkMedia_Logo_White.png' alt="hallmark media logo" /></Link>
                    </div>
                    <div className="media-socialLinks">
                        <p></p>
                        <div className="media-socialLinks-item">
                            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/pg/hallmarkchannel/"><i className="media-socialLinks-item-link soc-icon fab fa-facebook-f"></i></a>
                        </div>
                        <div className="media-socialLinks-item">
                            <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UC5T-sc4bz1eAEgMIamLLV6w"><i className="media-socialLinks-item-link soc-icon fab fa-youtube"></i></a>
                        </div>
                        <div className="media-socialLinks-item">
                            <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/hallmarkchannel?lang=en"><i className="media-socialLinks-item-link soc-icon fab fa-twitter"></i></a>
                        </div>
                        <div className="media-socialLinks-item">
                            <a target="_blank" rel="noopener noreferrer" href="http://www.pinterest.com/hallmarkchannel"><i className="media-socialLinks-item-link soc-icon fab fa-pinterest"></i></a>
                        </div>
                        <div className="media-socialLinks-item">
                            <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/hallmarkchannel/?hl=en"><i className="media-socialLinks-item-link soc-icon fab fa-instagram"></i></a>
                        </div>
                        <div className="media-socialLinks-item">
                            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/hallmark-channel"><i className="media-socialLinks-item-link soc-icon fab fa-linkedin"></i></a>
                        </div>
                    </div>

                    <ul className="navigation-footer-items">

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmarkchannel.com/" target="_blank" rel="noopener noreferrer">Hallmark Channel</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmarkmystery.com/" target="_blank" rel="noopener noreferrer">Hallmark Mystery</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmarkfamily.com/" target="_blank" rel="noopener noreferrer">Hallmark Family</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmarkplus.com" target="_blank" rel="noopener noreferrer">Hallmark+</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmarkchannel.com/about-us" target="_blank" rel="noopener noreferrer">About Us</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="http://corporate.hallmarkmedia.com/careers" target="_blank" rel="noopener noreferrer">Careers</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmarkchannel.com/faq" target="_blank" rel="noopener noreferrer">FAQ</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmarkchannel.com/advertising" target="_blank" rel="noopener noreferrer">Advertising</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="http://corporate.hallmarkmedia.com/" target="_blank" rel="noopener noreferrer">Corporate</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="http://press.hallmarkmedia.com" target="_blank" rel="noopener noreferrer">Press</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmarkchannel.com/channel-locator" target="_blank" rel="noopener noreferrer">Channel Locator</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmarkchannel.com/newsletter" target="_blank" rel="noopener noreferrer">Newsletter</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmark.com/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmark.com/terms-of-use/" target="_blank" rel="noopener noreferrer">Terms of Use</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmark.com/privacy-notice/" target="_blank" rel="noopener noreferrer">CA Privacy Notice</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmarkchannel.com//do-not-sell-my-info" target="_blank" rel="noopener noreferrer">CA Do Not Sell My Info</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="http://www.hallmark.com/" target="_blank" rel="noopener noreferrer">Hallmark Cards</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmarkchannel.com/games" target="_blank" rel="noopener noreferrer">Games</a></span>
                        </li>

                        <li className="navigation-footer-item">
                            <span className="navigation-footer-item-link"><a href="https://www.hallmarkchannel.com//accessibility-notice" target="_blank" rel="noopener noreferrer">Accessibility</a></span>
                        </li>

                    </ul>
                    <div className="navigation-footer-copyright">Copyright &copy; 2020 Hallmark Media, all rights reserved</div>

                </footer>
            </Container>
        </div>
    </StyledFooterWrapper>
)


export default Footer;